<login>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          <h3>Discomon Opener</h3>
        </div>
        <div class="card-body">
          <form onsubmit={ handleSubmit } novalidate>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input type="email" class="form-control { state.errors['email'] ? 'is-invalid' : '' }" id="email" name="email" value={ state.email } oninput={ handleInputChange } />
              <div class="invalid-feedback" if={ state.errors['email'] }>{ state.errors['email'] }</div>
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input type="password" class="form-control { state.errors['password'] ? 'is-invalid' : '' }" id="password" name="password" value={ state.password } oninput={ handleInputChange } />
              <div class="invalid-feedback" if={ state.errors['password'] }>{ state.errors['password'] }</div>
            </div>
            <div if={ state.errorMessage } class="alert alert-danger">
              { state.errorMessage }
            </div>
            <div class="d-grid gap-2">
              <button type="submit" class="btn btn-primary" disabled={ state.isLoading }>
                { state.isLoading ? 'Iniciando sesión...' : 'Iniciar sesión' }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <script>
    import { AuthService } from '../services/api-service'

    export default {
      onBeforeMount() {
        this.state = {
          isLoading: false,
          errorMessage: '',
          email: '',
          password: '',
          errors: {}
        }
      },

      handleInputChange(e) {
        const { name, value } = e.target
        this.update({
          errors: this.clearError(name),
          [name]: value
        })
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors
        }

        const errors = { ...this.state.errors }
        delete errors[name]
        return errors
      },

      validateForm() {
        const { email, password } = this.state
        const errors = {}

        if (!email.trim()) {
          errors.email = 'El correo electrónico es requerido'
        } else {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          if (!emailRegex.test(email)) {
            errors.email = 'El formato del correo electrónico no es válido'
          }
        }

        if (!password) {
          errors.password = 'La contraseña es requerida'
        }

        this.update({ errors })

        return Object.keys(errors).length === 0
      },

      async handleSubmit(e) {
        e.preventDefault()

        if (!this.validateForm()) {
          return
        }

        this.update({
          isLoading: true,
          errorMessage: ''
        })

        try {
          const email = this.state.email
          const password = this.state.password

          console.log('Intentando login con:', email)

          const success = await AuthService.login(email.toString(), password.toString())

          if (success) {
            this.props.onlogin()
          } else {
            this.update({
              errorMessage: 'Credenciales inválidas',
              isLoading: false
            })
          }
        } catch (error) {
          console.error('Error en login:', error)
          this.update({
            errorMessage: error instanceof Error ? error.message : 'Error en la autenticación',
            isLoading: false
          })
        }
      }
    }
  </script>

</login>
